<template>
    <div class="row py-3">
          <div class="col"><a href="#/" @click="setSelected('Autoshare')" :class="`switch_button ${active_autoshare}`">Autoshare</a></div>
          <div class="col"><a href="#/" @click="setSelected('MyWebs')" :class="`switch_button ${active_mywebs}`">MyWebs</a></div>
        </div>
</template>

<script>
export default {

    data() {
    return {
      myCategory: 'MyWebs',
      active_autoshare: 'active',
      active_mywebs: null,     
    };
  },

  methods: {
    changeCategory() {
        this.$emit('change-category', this.myCategory);
    },

    setSelected(option) {
      this.active_mywebs = option === 'MyWebs' ? 'active' : null;
      this.active_autoshare = option === 'Autoshare' ? 'active' : null;
      this.myCategory = option;
      this.changeCategory();
    },
  }

}

</script>

<style scoped>
.switch_button {
  padding: 0.5rem 0.5rem;
  border: 1px solid #000;
  border-radius: 5px;
  color: #000;
  text-decoration: none;
  background-color: #fff;
  display:block;
  text-align: center;
}

.switch_button.active {
  color: #fff;
  background-color: #000;
}

.clear-text {
  text-transform: none !important;
  font-size: 0.8rem;
  position:relative;
  top:-2px;
}
.clear-container {
  top: 4px;
  right: 15px;
  cursor: pointer;
  font-size: 1rem;
  position: absolute;
}
</style>